export default __webpack_public_path__ + "static/media/bag1.d8c5edf3.jfif";